// Leitura do Evangelho do dia: transforma a referência crua ("Mc 10, 46-52")
// em dados para a prateleira dos Evangelhos e para os dois números grandes.
// Se não casar com o padrão, devolvemos null e a tela mostra só a referência.

export interface LeituraBiblia {
  sigla: string; // 'Mt'
  livro: string; // 'Mateus'
  ordem: number; // 1..4 (ordem no Novo Testamento)
  capitulo: string; // '11'
  versiculos: string; // '42 a 46'
}

const LIVROS: Record<string, { livro: string; ordem: number }> = {
  Mt: { livro: 'Mateus', ordem: 1 },
  Mc: { livro: 'Marcos', ordem: 2 },
  Lc: { livro: 'Lucas', ordem: 3 },
  Jo: { livro: 'João', ordem: 4 },
};

export const EVANGELHOS = ['Mateus', 'Marcos', 'Lucas', 'João'];

export function parseEvangelho(ref?: string | null): LeituraBiblia | null {
  if (!ref) return null;
  const m = ref.trim().match(/^(Mt|Mc|Lc|Jo)\s*(\d+)\s*,\s*(.+)$/);
  if (!m) return null;
  const info = LIVROS[m[1]];
  if (!info) return null;
  const versiculos = m[3]
    .trim()
    .replace(/\s*-\s*/g, ' a ')
    .replace(/\s*\.\s*/g, ' e ')
    .replace(/,\s*/g, ' e ');
  return {
    sigla: m[1],
    livro: info.livro,
    ordem: info.ordem,
    capitulo: m[2],
    versiculos,
  };
}